module.exports = __webpack_public_path__ + "static/media/petfront.5b2609e6.png";